<template>
    <v-dialog v-model="show" max-width="500">
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">로그인</h3>
                <v-btn fab color="transparent" @click="cancel" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-row class="row--x-small">
                    <v-col cols="12">
                        <v-text-field v-model="username" placeholder="아이디" outlined persistent-placeholder hide-details />
                    </v-col>
                    <v-col cols="12">
                        <v-password-field v-model="password" placeholder="비밀번호" outlined persistent-placeholder hide-details @keydown.enter="login" />
                    </v-col>
                </v-row>
                <v-row class="row--x-small">
                    <v-col cols="12">
                        <v-btn x-large block color="primary" @click="login">로그인</v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn x-large block outlined color="grey" to="/join"><span class="grey--text text--darken-3">회원가입</span></v-btn>
                    </v-col>
                </v-row>
            </div>
            <div class="v-card--dialog__body">
                <v-row no-gutters align="center" class="row--small">
                    <v-col cols="auto">
                        <v-checkbox v-model="isRemember" label="아이디 저장" hide-details class="ma-0 font-size-14"/>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn small text color="grey darken-1" to="/member/idpw" class="font-weight-regular mr-n12px">아이디/비밀번호 찾기</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
export default {
    components: {
        VPasswordField
    },
    data(){
        return {
            show: false,

            username: null,
            password: null,
            isRemember: false,
        };
    },
    methods: {
        close(){
            this.show = false;
        },
        cancel(){
            this.close();
        },
        open(){
            this.show = true;
        },
        validate(){
            try{
                if(!this.username) throw new Error("아이디를 입력해주세요");
                if(!this.password) throw new Error("비밀번호를 등록해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async login(){
            try{
                if(this.validate()){
                    await this.$store.dispatch("login", {
                        username: this.username,
                        password: this.password
                    });

                    if(this.isRemember) this.$cookies.set("username", this.username);

                    this.$emit("login");
                    this.close();
                }
            }
            catch(error){
                alert(error?.response?.data?.message ?? error.message);
            }
        },
    },
    watch: {
        show(){
            if(!this.show) this.$emit("close");
        }
    }
}
</script>

<style scoped>
</style>